module.exports = __webpack_public_path__ + "static/media/Circular Std Bold.961a181d.ttf";